import { ref, computed, watch } from "@vue/composition-api";
import { useToast } from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import moment from "moment-timezone";
import store from "@/store";
import ability from "@/libs/acl/ability";
import { useUtils as useI18nUtils } from "@core/libs/i18n";
import { decryptData } from "@/utils/decryptUserDataUtils";

export default function useList() {
  const user = JSON.parse(decryptData(window.localStorage.userData));
  const { t } = useI18nUtils();
  const trans = {
    "messages.error.server_error": t("messages.error.server_error"),
  };
  const refListTable = ref(null);

  const toast = useToast();

  store.dispatch('helpdesk_group/getAll')
  const groupsOptions = computed(() => store.getters['helpdesk_group/getSelectedItems'])
  const groupsFilter = ref(null)

  const tableColumns = [
    //{ label: "id", key: "id", sortable: true },
    { label: "helpdesk.ticket.name", key: "name", sortable: true },
    { label: "helpdesk.ticket.from", key: "from", sortable: true },
    { label: "helpdesk.ticket.title", key: "subject", sortable: true },
    { label: "helpdesk.ticket.message", key: "message", sortable: true, tdClass: 'text-truncate message-t', thStyle: 'max-width: 150px;' },
    { label: "helpdesk.group.title", key: "group", sortable: false, formatter: (value, key, item) => {
      if(item.group) return [...new Set(item.group.map(item => { return item.name}))].join(', ')
      return ''
      }
    },
    { label: "helpdesk.ticket.priority", key: "priority", sortable: true },
    { label: 'date.created_at', key: 'created_at', sortable: true, formatter: 'formatDateAssigned' },
    { label: 'date.updated_at', key: 'updated_at', sortable: true, formatter: 'formatDateAssigned' },
  ];
  if (
    ability.can("update", "HelpdeskTicket") ||
    ability.can("delete", "HelpdeskTicket")
  ) {
    tableColumns.splice(0, 0, { label: "actions.name", key: "actions" });
  }

  const perPage = ref(10);
  const totalList = ref(0);
  const currentPage = ref(1);
  const perPageOptions = [10, 25, 50, 100];
  const searchQuery = ref("");
  const sortBy = ref("id");
  const isSortDirDesc = ref(true);

  const dataMeta = computed(() => {
    const localItemsCount = refListTable.value ? refListTable.value.localItems.length : 0;
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalList.value,
    };
  });

  const fetchList = (ctx, callback) => {

    let params = {
      q: searchQuery.value,
      max: perPage.value,
      "page[n]": currentPage.value,
      sortBy: sortBy.value,
      sortDesc: isSortDirDesc.value,
    }

    if(!user.is_master_admin){
      if(user.enabled_helpdesk){
        params.assigned_history = user.id
      }
      params.id_user = user.id
    }

    store
     .dispatch("helpdesk_ticket/getAll", params)
      .then((response) => {
        callback(response.data);
        totalList.value = response.meta.total;
      })
      .catch(() => {
        toast({
          component: ToastificationContent,
          props: {
            title: trans["messages.error.server_error"],
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      });
  };

  const formatDateAssigned = (value) => {
    const formattedDate = moment(value).format("DD/MM/YYYY HH:mm:ss");
    return formattedDate;
  };

  const refetchData = () => {
    refListTable.value.refresh();
  };

  watch([currentPage, perPage, searchQuery], () => {
    refetchData();
  });

  return {
    tableColumns,
    perPage,
    currentPage,
    totalList,
    fetchList,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refListTable,
    formatDateAssigned,
    groupsOptions,
    refetchData,
  };
}
